import axios from 'axios';
import { v4 as randomId } from 'uuid';
const main_base_URL = 'https://api.datingclassifiedads.com';
const buckets = {
  letter: 'live-chat-letters-files',
  video: 'dating-date-videos',
  photo: 'dating-date-photos',
};

// Функція для отримання розширення
const getExtensionFromMime = mime => mime.split('/')[1];

const getUploadFileUrl = async ({ filename, fileType, type, isLetterFile }) => {
  const res = await axios.get(main_base_URL + `/file/upload-url`, {
    params: {
      filename,
      fileType,
      type,
      isLetterFile,
    },
  });
  return res.data;
};

const getPublicFileUrl = (fileName, type, isLetterFile) => {
  const bucket = isLetterFile
    ? buckets.letter
    : buckets[type.split('/')[0]] || buckets.photo;

  return `https://${bucket}.s3.us-east-2.amazonaws.com/${fileName}.${
    type.split('/')[1]
  }`;
};

export const uploadFile = async (file, isLetterFile) => {
  const extension = getExtensionFromMime(file.type);
  const id = randomId();
  const fileName = `${id}.${extension}`;
  const uploadUrl = await getUploadFileUrl({
    filename: fileName,
    fileType: file.type,
    type: file.type.split('/')[0],
    isLetterFile: true,
  });
  await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'Cache-Control': 'public, max-age=31536000',
    },
    body: file,
  });
  const url = getPublicFileUrl(id, file.type, true);
  return url;
};
